import { FormControl, FormHelperText, InputBase, InputLabel } from '@mui/material';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';

import { composeValidations, validateRequired } from './formValidations';

const TIME_24H_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;

const TimeField = ({ name, id, label, required, helperText, validations }) => {
  const validate = composeValidations([
    (value) =>
      value && !TIME_24H_REGEX.test(value) ? 'Enter a time between 00:00 and 23:59' : undefined,
    ...validations,
    ...(required ? [validateRequired('Required')] : []),
  ]);

  return (
    <Field
      name={name}
      id={id}
      validate={validate}
      render={({ input, meta }) => {
        const showError = !!meta.error && (!!meta.dirty || !!meta.touched);
        const displayedHelperText = (!!meta.touched && meta.error) || helperText;

        return (
          <FormControl error={showError} variant='standard' fullWidth>
            <InputLabel shrink htmlFor={id} required={required} sx={{ fontSize: '1.2em' }}>
              {label}
            </InputLabel>

            <InputBase
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...input}
              value={input.value || ''}
              onChange={(event) => input.onChange(event.target.value)}
              sx={{
                py: 0.5,
                pl: 1,
                pr: 2.5,
                '&:focus, &.Mui-focused': { pr: 2.3 },
                'label + &': {
                  marginTop: '1.3em',
                },
                marginTop: '1.3em',
                boxSizing: 'border-box',
                borderRadius: 1,
                marginBottom: 0.25,
                '&:focus, &:focus&:invalid, &.Mui-focused': {
                  borderWidth: 2,
                  py: '3px',
                  pl: 0.9,
                  pr: 2.3,
                },
              }}
              id={id}
              label={label}
              required={required}
              type='time'
              inputProps={{
                step: 60,
                min: '00:00',
                max: '23:59',
                'aria-required': required,
              }}
            />

            <FormHelperText sx={{ minHeight: '0.5rem' }}>{displayedHelperText}</FormHelperText>
          </FormControl>
        );
      }}
    />
  );
};

TimeField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  validations: PropTypes.arrayOf(PropTypes.func),
  required: PropTypes.bool,
  helperText: PropTypes.string,
};

TimeField.defaultProps = {
  validations: [],
  required: false,
  helperText: '',
};

export default TimeField;
